import colors from "../colors";

export default colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/Dark2.js
// module id = 1054
// module chunks = 0